import styles from "./PreviewBar.module.css";
import { CloseIcon } from "components/Icons";

export const PreviewBar = () => (
  <button
    className={styles.button}
    onClick={() => (window.location.href = "/api/exit-preview")}
  >
    <span className={styles.label}>Preview sluiten</span>
    <span className={styles.iconWrapper}>
      <CloseIcon />
    </span>
  </button>
);
